import React, { Fragment } from 'react';
import { View } from 'react-native';

import { TextPropTypes } from 'deprecated-react-native-prop-types';
import { map as _map } from 'lodash';
import PropTypes from 'prop-types';

import { VFText, Icon } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import styles from './DeviceInfo.Styles.js';

const renderExtraInfo = (extraInfo, extraInfoTitleStyle, extraInfoSubTitleStyle, theme) => {
  return _map(extraInfo, item => {
    const { title, subTitle } = item;
    return (
      <Fragment key={item.title}>
        <VFText style={[styles.deviceLableStyle(theme), extraInfoTitleStyle]} i18nKey={title} />
        {React.isValidElement(subTitle) ? (
          subTitle
        ) : (
          <VFText
            style={[styles.deviceInfoValue(theme), extraInfoSubTitleStyle]}
            i18nKey={subTitle}
          />
        )}
      </Fragment>
    );
  });
};

const DeviceInfo = ({
  name,
  type,
  deviceTypeAccessibilityLabel,
  deviceNameAccessibilityLabel,
  image,
  iconSize,
  extraInfo,
  extraInfoTitleStyle,
  extraInfoSubTitleStyle,
  theme,
}) => {
  return (
    <View style={styles.headerTitleViewStyle}>
      <View style={styles.usageIconViewStyle}>
        <Icon name={image} type="image" size={iconSize} />
      </View>
      <View>
        <VFText
          style={styles.deviceLableStyle(theme)}
          i18nKey={type}
          testKey={deviceTypeAccessibilityLabel}
        />
        <VFText
          style={styles.deviceNameStyle(theme)}
          i18nKey={name}
          testKey={deviceNameAccessibilityLabel}
        />
        {renderExtraInfo(extraInfo, extraInfoTitleStyle, extraInfoSubTitleStyle, theme)}
      </View>
    </View>
  );
};
DeviceInfo.propTypes = {
  name: PropTypes.string,
  type: PropTypes.string,
  deviceTypeAccessibilityLabel: PropTypes.string,
  deviceNameAccessibilityLabel: PropTypes.string,
  image: PropTypes.object,
  iconSize: PropTypes.number,
  extraInfo: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    }),
  ),
  extraInfoTitleStyle: TextPropTypes.style,
  extraInfoSubTitleStyle: TextPropTypes.style,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
};
export default withTheme(DeviceInfo);
